import { Component, Inject, OnInit } from '@angular/core';
import { BannerConfig } from './orderbanners/bannerconfig';
import { ApiRequestService } from '../shared/api-request-service';
import { ToastmessageService } from '../toastmessage/toastmessage.service';
import { GetBannersResponse } from './orderbanners/getbannersresponse';
import { DeletebannerpopupComponent } from './deletebannerpopup/deletebannerpopup.component';
import { Router } from '@angular/router';
import { MatdialogService } from '../matdialog/matdialog.service';

@Component({
    selector: 'app-addbanners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.scss']
})
export class BannersComponent implements OnInit {
    getBannersUrl = '/admin/get-banners';

    banners: BannerConfig[] = [];

    configuratorBaseUrl = '';

    searchText = '';

    constructor(
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _router: Router,
        private _matdialogService:MatdialogService
    ) {
        this.configuratorBaseUrl = _configuratorBaseUrl;
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this._apiRequestService
                .sendRequest<{}, GetBannersResponse>(this.configuratorBaseUrl, true, {}, true, this.getBannersUrl)
                .subscribe((response) => {
                    this.banners = response.bannerConfigEntityList as BannerConfig[];
                });
        } else {
            this._router.navigateByUrl('/');
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    openDeleteBannerPopup(banner: BannerConfig) {
        this._matdialogService.openPopupWithData(banner,DeletebannerpopupComponent);
    }
}
